import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

export class IncomeTaxEntriesCard extends Component {

    handleFormChange = (event) => {
        const { name, value } = event.target;
        const { index, entry } = this.props;
        let updatedEntry = {...entry};
		updatedEntry = {
			...updatedEntry,
			[name]: value
		}
		this.props.onUpdateEntry(updatedEntry, index);
    }

    render() {

        const { entry={}, index } = this.props;

        const {
            annualSalaryFrom,
            annualSalaryTo,
            taxFixedAmount,
            taxRate,
            exemptAmount,
        } = entry;


        return (
            <Card
                hideFooter
                key={`IncomeTax-${index}`}
                title={`Entry`}
                content={
                    <Row>
                        <Col sm={12} md={3}>
                            <FormGroup>
                            <ControlLabel>Annual Salary From</ControlLabel>
                            <FormControl
                                type="number"
                                name="annualSalaryFrom"
                                value={annualSalaryFrom}
                                onChange={this.handleFormChange}
                                placeholder=""
                            />
                            </FormGroup>
                        </Col>
                        <Col sm={12} md={3}>
                            <FormGroup>
                            <ControlLabel>Annual Salary To</ControlLabel>
                            <FormControl
                                type="number"
                                name="annualSalaryTo"
                                value={annualSalaryTo}
                                onChange={this.handleFormChange}
                                placeholder=""
                            />
                            </FormGroup>
                        </Col>
                        <Col sm={12} md={2}>
                            <FormGroup>
                            <ControlLabel>Tax Fixed Amount</ControlLabel>
                            <FormControl
                                type="number"
                                name="taxFixedAmount"
                                value={taxFixedAmount}
                                onChange={this.handleFormChange}
                                placeholder=""
                            />
                            </FormGroup>
                        </Col>
                        <Col sm={12} md={2}>
                            <FormGroup>
                            <ControlLabel>Tax Rate</ControlLabel>
                            <FormControl
                                type="number"
                                name="taxRate"
                                value={taxRate}
                                onChange={this.handleFormChange}
                                placeholder=""
                            />
                            </FormGroup>
                        </Col>
                        <Col sm={12} md={2}>
                            <FormGroup>
                            <ControlLabel>Exempt Amount</ControlLabel>
                            <FormControl
                                type="number"
                                name="exemptAmount"
                                value={exemptAmount}
                                onChange={this.handleFormChange}
                                placeholder=""
                            />
                            </FormGroup>
                        </Col>
                    </Row>
                }
            />
        )
	}
}

export default IncomeTaxEntriesCard;
